export const version = 'quarterly';
export const libraries = ['drawing', 'geometry', 'places'];
export const googleMapsApiKey = 'AIzaSyBg3iYyycTNutbbCzFmhd5W_kt4eodjbIQ';
